import LogoL from './images/logo.png'
import Entrance from './images/backdrops/entrance.jpg'
import EntranceM from './images/backdrops/entranceP.jpg'
import LobbyL from './images/backdrops/lobby.jpg'
import Exhibition from './images/backdrops/exhibition.jpg'
import Auditorium from './images/backdrops/auditorium.jpg'
import MC from './images/backdrops/MC20.png'
import NetworkingL from './images/backdrops/networking.jpg'
import LobbyMusic from './images/audio/lobby.mp3'
import routes from './routes'
import Gallerium from './images/backdrops/gallerium.jpg'
import CountdownL from './images/registration/countdownL.jpg'
import PostRegisterL from './images/registration/BG_Desktop.jpg'
import PostRegisterM from './images/registration/BG_Mobile.jpg'

const dev = {
  apiUrl: 'http://localhost:3000',
}

const prod = {
  apiUrl: 'https://nnknowyourinsulin.herokuapp.com',
}

const API_KEYS = {
  amplitude: '210fc2c032c7994a3b749a1c6097d3cf',
}

const eventDays = [19, 20, 22]

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  logo: {
    landscape: LogoL,
    portrait: LogoL,
  },
  postRegister: {
    landscape: PostRegisterL,
    portrait: PostRegisterM,
  },
  countdown: {
    landscape: CountdownL,
    portrait: CountdownL,
  },
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyL,
  },
  auditorium1: Auditorium,
  auditorium2: MC,

  exhibition: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingL,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,
}

const layout = {
  auditoriumVid: `
    top: 10%;
    bottom: 38%;
    left: 12.8%;
    right: 35%;
  `,
}

const lobbyEntries = [
  {
    id: 'auditorium',
    destination: routes.auditorium1,
    css: `
      top: 61%;
      left: 34.5%;
      right: 60.5%;
      bottom: 39%;
    `,
  },
  {
    id: 'exhibition',
    destination: routes.exhibition,
    css: `
      top: 61%;
      left: 73.4%;
      right: 19.5%;
      bottom: 39.5%;
    `,
  },
  {
    id: 'helpdesk',
    destination: 0,
    css: `
      top: 80.5%;
      left: 6.5%;
      right: 91%;
      bottom: 19.5%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  eventDays,

  eventName: 'Novo Nordisk Know Your Insulin Virtual Launch 2021',
  googleAnalyticsID: '',

  ...config,
}
